import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import store from './store'
import '@/permission' // permission control



import ElementUI from 'element-ui';


import VueVideoPlayer from 'vue-video-player'
import video from 'video.js'
import GLOBAL from './utils/global_variable'
import 'babel-polyfill'
import $ from 'jquery'
// 或者
require("es6-promise").polyfill();
require('babel-polyfill') //es6

import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css';

//在main.js中使用


Vue.use(ElementUI);
Vue.use(Avue,axios);

Vue.use(VueVideoPlayer)
Vue.prototype.videojs = video
Vue.prototype.baseUrl = GLOBAL.baseURL
Vue.prototype.baseBackUrl = GLOBAL.baseBackURL
Vue.config.productionTip = false



new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js